import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ToolbarButton } from '../../models/toolbar.models';

@Component({
  selector: 'app-panel-toolbar',
  templateUrl: './panel-toolbar.component.html',
  styleUrl: './panel-toolbar.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PanelToolbarComponent {
  @Input('buttons') buttons: ToolbarButton[];
}
